// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scannerContainer_wTY4Q { 
    z-index : 100;
    background-color : var( --color-white ); 
    overflow: hidden !important;
    min-height: 208px;
    height: 100%;
    position: relative;
}

.scannerClose_JBItP { 
  position : absolute;
  top : 8px;
  right : 8px;
  color : var( --color-white );
  z-index: 1;
}
  
.scannerUpload_F4lGD { 
  position : absolute;
  bottom : 8px;
  left : 8px;
}

.fullscreen_FtHCh {
  position : absolute;
  bottom : 8px;
  right : 8px;
  color : var( --color-white );
  cursor: pointer;
  z-index: 1;
}

.notFound_Jd3bN {
  width: 311px;
  padding: var(--size-padLarge);
}

.fullWidth_t_4b4 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/r4k/views/installGateway/Scan.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uCAAuC;IACvC,2BAA2B;IAC3B,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb","sourcesContent":[".scannerContainer { \n    z-index : 100;\n    background-color : var( --color-white ); \n    overflow: hidden !important;\n    min-height: 208px;\n    height: 100%;\n    position: relative;\n}\n\n.scannerClose { \n  position : absolute;\n  top : 8px;\n  right : 8px;\n  color : var( --color-white );\n  z-index: 1;\n}\n  \n.scannerUpload { \n  position : absolute;\n  bottom : 8px;\n  left : 8px;\n}\n\n.fullscreen {\n  position : absolute;\n  bottom : 8px;\n  right : 8px;\n  color : var( --color-white );\n  cursor: pointer;\n  z-index: 1;\n}\n\n.notFound {\n  width: 311px;\n  padding: var(--size-padLarge);\n}\n\n.fullWidth {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scannerContainer": `scannerContainer_wTY4Q`,
	"scannerClose": `scannerClose_JBItP`,
	"scannerUpload": `scannerUpload_F4lGD`,
	"fullscreen": `fullscreen_FtHCh`,
	"notFound": `notFound_Jd3bN`,
	"fullWidth": `fullWidth_t_4b4`
};
export default ___CSS_LOADER_EXPORT___;
